import { __awaiter, __generator } from "tslib";
import { fetchGroupAttributes } from '@gn-audio/core/api/product-catalogue/fetch-group-attributes';
import { fetchProductsBySkus } from '@gn-audio/core/api/product-catalogue/fetch-products-by-skus';
/**
 * Checks whether product SKU is allowed for engraving
 * @param sku Product SKU to check (External reference ID)
 * @returns Boolean value indicating whether engraving is allowed for specified product SKU
 * @async
 */
export var isProductAllowedForEngraving = function (sku) { return __awaiter(void 0, void 0, void 0, function () {
    var productEngravingKey, products, groupId, productGroup, engravingAttribute;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                productEngravingKey = 'Product_Engraving';
                return [4 /*yield*/, fetchProductsBySkus([sku])];
            case 1:
                products = _b.sent();
                if (!Array.isArray(products) || products.length === 0) {
                    return [2 /*return*/, false];
                }
                groupId = products[0].groupId;
                return [4 /*yield*/, fetchGroupAttributes(groupId, "available" /* IncludeType.Available */)];
            case 2:
                productGroup = _b.sent();
                engravingAttribute = (_a = productGroup === null || productGroup === void 0 ? void 0 : productGroup.attributes) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.key === productEngravingKey; });
                return [2 /*return*/, engravingAttribute !== undefined && engravingAttribute.value === 'True'];
        }
    });
}); };
